module.exports = __webpack_public_path__ + "static/media/img-307afe2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/linc-logo.png
// module id = 5291
// module chunks = 39